import './index.scss'
import { observer } from 'mobx-react-lite'
import XImg from '@assets/svg/x.svg'
import { Context } from '@/index'
import { useContext } from 'react'
// ----------------
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
// ----------------
import { updateProfile as updateProfileApi } from '@api/user-api';
import { toast } from 'react-toastify';
import { toastOptions } from '@shared/index';

const validationSchema = Yup.object().shape({
    bio: Yup.string()
        .required('Özünüz haqqında məlumat daxil edin')
        .min(16, 'Özünüz haqqında məlumat ən azı 16 simvoldan ibarət olmalıdır')             
        .max(1200, 'Özünüz haqqında məlumat ən çox 1200 simvoldan ibarət olmalıdır'),               
})
const formOptions = { resolver: yupResolver(validationSchema), shouldUnregister: true }

const EditBioModal = observer(({ savedAboutMe, callback }) => {
    const { modal } = useContext(Context);
    const { register, handleSubmit, formState: { errors } } = useForm(formOptions);

    const onSubmit = (data) => {
        console.log(data);
        const updateProfile = {
            about_me: data.bio,
        }
        updateProfileApi(updateProfile)
        .then(() => {
            callback();
            toast.success('Özünüz haqqında məlumat uğurla saxlanıldı', toastOptions);
            modal.closeModal();
        })
        .catch(() => {
            callback();
            toast.error('Özünüz haqqında bölmənin dəyişdirilməsində xəta baş verdi', toastOptions);
            modal.closeModal();
        })
    }

    return (
        <div className="edit-bio-modal">
            <div className="header-modal">
Özünüz haqqında məlumatı redaktə et
                <div className="x-block" onClick={() => modal.closeModal()}>
                    <img src={XImg} className="x"/>
                </div>
            </div>
            <form className="form" onSubmit={handleSubmit(onSubmit)}>
                <div className="form-control-block">
                    <label htmlFor="bio" className="form-label">
Özünüz haqqında qısaca yazın - sizi nə maraqlandırır, hansı sahələr sizin üçün ən maraqlıdır və s.
                    </label>
                    <textarea
                        className="form-control"
                        id="bio"
                        rows="4" 
                        placeholder="" 
                        {...register("bio")}
                        defaultValue={savedAboutMe}
                    >
                    </textarea>
                    {errors.bio?.message && (
                        <p className="error">{errors.bio?.message}</p>
                    )}
                </div>
                <div className="actions">
                    <button type='button' className="cancel" onClick={() => modal.closeModal()}>
Ləğv et
                    </button>
                    <button type='submit' className="confirm">
Saxla
                    </button>
                </div>
            </form>
        </div>
    )
})

export { EditBioModal }